import Linkify from 'linkify-react';
import parse from 'html-react-parser';

export default function LinkifyCustom({ text, isSentByMe }) {
  const options = {
    target: '_blank',
    rel: 'noopener noreferrer',
    className: isSentByMe ? 'custom-link' : 'custom-link--guest',
  };
    
  return <Linkify options={options}>{parse(text)}</Linkify>;
}